var map = {
	"./favicon-16x16": 8,
	"./favicon-16x16.png": 8,
	"./favicon-32x32": 9,
	"./favicon-32x32.png": 9,
	"./favicon.ico": 22,
	"./logo-klinikum-email": 10,
	"./logo-klinikum-email.png": 10
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21;